import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { createStore } from 'redux';
import { BrowserRouter } from 'react-router-dom'

import MainReducer from './reducers/main-reducer';

import App from './App';
import * as registerServiceWorker from './registerServiceWorker';

if (process.env.NODE_ENV === "production") {
  // Keep error/warn, only silence log/info/debug
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  // If you also want to kill warn/error, uncomment:
  // console.warn = () => {};
  // console.error = () => {};
}
const store = createStore(MainReducer);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker.unregister();
